export interface IChatConfig {
  chat?: IChat;
}

export interface IChat {
  departments?: IChatDepartment[];
}

export interface IChatDepartment {
  active?: boolean;
  isDefault?: boolean;
  name?: string;
  product_detail_department?: null | string;
  product_detail_button?: IProductDetailButton | null;
  product_detail_chat_provider?: string;
}

export interface IProductDetailButton {
  title?: string;
  description?: string;
  iconUrl?: string;
  schedule?: string;
}

export const defaultChatConfig = {
  chat: {
    departments: [
      {
        active: true,
        isDefault: true,
        name: 'Soporte 24 horas',
        product_detail_department: null,
        product_detail_button: null,
      },
      {
        active: true,
        isDefault: false,
        name: 'Asesoría Farmacéutica Lun a Sab 10am a 7pm',
        product_detail_department: 'salud y medicamentos',
        product_detail_chat_provider: 'kustomer',
        product_detail_button: {
          title: 'Consulta en línea con un asesor farmacéutico',
          description: 'Ej: ¿Este medicamento lo puedo tomar embarazada?',
          iconUrl: 'https://lh3.googleusercontent.com/mco4DU4KaWYEHFv53F7LckKzh99FDZcqm5pJ7EaeYbKFBgQ8YyM71poNf64QjemE06WELZX1OIjXCBhbyeoB7QDvH47HQ-Uy1Qspf7uHD2rzqvMM',
          schedule: 'L-S 10 am a 7 pm',
        },
      },
      {
        active: false,
        isDefault: false,
        name: 'Asesoría cotidinana',
        product_detail_department: 'hogar, mascotas y otros.',
        product_detail_chat_provider: 'zendesk',
        product_detail_button: {
          title: 'Consulta en línea con un asesor',
          description: 'Ej: ¿Este medicamento lo puedo tomar embarazada?',
          iconUrl: 'https://lh3.googleusercontent.com/mco4DU4KaWYEHFv53F7LckKzh99FDZcqm5pJ7EaeYbKFBgQ8YyM71poNf64QjemE06WELZX1OIjXCBhbyeoB7QDvH47HQ-Uy1Qspf7uHD2rzqvMM',
          schedule: '24 horas',
        },
      },
    ],
  },
};
